<template lang="pug">
  div.wrapper-map
    #viewDiv
</template>

<script>
import { loadModules } from 'esri-loader'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      mapTitle: 'Create Map'
    }
  },
  computed: mapGetters({
    // selectedLayers: 'getSelectedLayers',
    // routerQuery: 'getRouterQuery'
  }),
  methods: {
    createMap (vue, router, title) {
      loadModules(
        [
          'esri/Map',
          'esri/layers/FeatureLayer',
          'esri/views/MapView',
          'esri/layers/MapImageLayer',
          'esri/widgets/Legend',
          'esri/widgets/Expand',
          'esri/config',
          'esri/core/urlUtils',
          'esri/request'
        ],
        { url: this.$store.state.config.arcgis }
      ).then(
        ([
          Map,
          FeatureLayer,
          MapView,
          MapImageLayer,
          Legend,
          Expand,
          esriConfig,
          urlUtils,
          esriRequest
        ]) => {
          let _this = this
          let map

          let selectedActions = _this.$store.state.actions.filter(action => action['Azioni.idAzione'] === this.$route.params.id)
          let idAzione = selectedActions[0]['Azioni.idAzione']

          if (!_this.$store.state.map) {
            // console.log('object NOT stored')
            map = new Map({ basemap: 'streets-vector' })
            _this.$store.commit('SET_ESRI_MAP', map)
          } else {
            // console.log('object stored')
            map = _this.$store.state.map
          }

          let webCartLayer = new MapImageLayer({ url: _this.$store.state.config.MapServer.url })
          _this.$store.commit('SET_CART_LAYER', webCartLayer)
          map.layers.add(webCartLayer)
          webCartLayer.when(() => {
            _this.$store.commit('SET_ACTION_LAYERS', webCartLayer.allSublayers.items)
            webCartLayer.allSublayers.find(sl => sl.title === 'DATI CARTOGRAFICI').visible = false

            const legend = new Expand({
              content: new Legend({
                view: view,
                layerInfos: [{
                  layer: webCartLayer,
                  title: 'Legenda'
                }, {
                  layer: layer,
                  title: 'Intervento'
                }]
              }),
              expanded: true
            })
            view.ui.add(legend, 'bottom-right')
          })

          let layer = new FeatureLayer({
            url: _this.$store.state.config.MapServer.url + '0'
          })
          // map.removeAll()
          map.add(layer)

          let view = new MapView({
            container: 'viewDiv',
            map,
            center: [12.51133, 41.89193],
            zoom: 5
          })

          layer.when(() => {
            layer.definitionExpression = "idAzione = '" + idAzione + "'"
          })

          // when the view is redered center to the feature selected
          view.when((v) => {
            // check the extent of the layer and center the map on it
            layer.queryExtent()
              .then((response) => {
                v.goTo({
                  target: response.extent
                }).then((r) => {
                  view.zoom -= 1
                })
              })
          })
        }
      )
    }
  },
  mounted () {
    this.createMap(this, this.$router, this.mapTitle)
  },
  destroyed () {
    // console.log('map: Destroy')
  },
  beforeDestroy () {
    // console.log('map: beforeDestroy')
    // this.$store.state.watchHandle.remove()
  }
}
</script>
<style scoped>
@import url("https://js.arcgis.com/4.4/esri/themes/light/main.css");
.wrapper-map {
  position: relative;
  height: 90.7vh;
}
#viewDiv {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/TheMap.vue